module.exports = __webpack_public_path__ + "static/media/matsumoto.698306a2.webp";